var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6913 8.84184C18.7015 7.60848 17.3129 6.89496 16.002 6.89496C14.2678 6.89496 13.535 7.71888 12.3319 7.71888C11.0918 7.71888 10.1489 6.89616 8.64888 6.89616C7.17552 6.89616 5.60904 7.79112 4.61592 9.32064C3.2184 11.4715 3.45504 15.5184 5.72112 18.967C6.5316 20.2001 7.614 21.5868 9.02928 21.6C10.2871 21.6115 10.643 20.7977 12.3497 20.7881C14.0566 20.7787 14.3794 21.6089 15.637 21.5971C17.0522 21.5837 18.1942 20.0482 19.0042 18.8148C19.5847 17.9314 19.801 17.485 20.2519 16.4863C16.9757 15.2484 16.4489 10.619 19.6913 8.84184Z",
    fill: "#11142D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6866 5.51712C15.3166 4.7088 15.7951 3.56688 15.6214 2.4C14.5923 2.47104 13.3884 3.12552 12.6857 3.9792C12.0478 4.75392 11.521 5.9028 11.7259 7.01952C12.8494 7.05432 14.0119 6.38304 14.6866 5.51712Z",
    fill: "#11142D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.0faaac19d6efa4ad40d5d1ee3145b395.svg";
export { ForwardRef as ReactComponent };